import * as angular from 'angular';
import * as $ from "jquery";

"use strict";

angular
    .module('FieldModule')
    .factory('CrossBlocDataUpdatesFieldFactory', CrossBlocDataUpdatesFieldFactory);


CrossBlocDataUpdatesFieldFactory.$inject = ['fieldService', 'Configuration', '$http'];


/**
 * Object that will create a Plain Data Factory, all methods of factory
 * will be available from outside.
 */
function CrossBlocDataUpdatesFieldFactory(fieldService, Configuration, $http) {
    let factory = this;

    /**
     * Method responsible for setting the field parameters from edit
     * @param fieldParameters
     * @returns {*}
     */


    /**
     * Method responsible for building and editing the local matching fields Array for updating checking against
     * @param localFieldMatchingFieldPairsArray
     * @param action
     * @param localField
     * @param remoteField
     * @param index
     * @returns {*}
     */
    factory.addOrRemoveMatchingFieldPairs = function (localFieldMatchingFieldPairsArray, action, localField, remoteField, index = null) {

        if((localField == '' || typeof localField == 'undefined') && action == 'add') {
            alert('Please Select a local Field');
            return localFieldMatchingFieldPairsArray;
        }

        if((remoteField == '' || typeof remoteField == 'undefined') && action == 'add') {
            alert('Please Select a remote field it must match');
            return localFieldMatchingFieldPairsArray;
        }

        if(typeof localFieldMatchingFieldPairsArray == 'undefined') {
            localFieldMatchingFieldPairsArray = {};
        }

        if(action == 'add') {
            localField = JSON.parse(localField);
            remoteField = JSON.parse(remoteField);
            console.log(localFieldMatchingFieldPairsArray);
            localFieldMatchingFieldPairsArray[Object.keys(localFieldMatchingFieldPairsArray).length] = {
                'localFieldId' : localField.id,
                'remoteFieldId' : remoteField.id,
                'localFieldName' : localField.field_name,
                'remoteFieldName' : remoteField.field_name
            };

        } else {
            delete localFieldMatchingFieldPairsArray[index];
            // build new object with fresh keys to keep it in sync
            var fieldListForLoop = localFieldMatchingFieldPairsArray;
            localFieldMatchingFieldPairsArray = {};
            var i = 0;
            angular.forEach(fieldListForLoop, function(value) {
                localFieldMatchingFieldPairsArray[i] = value;
                i++;
            });
        }

        return localFieldMatchingFieldPairsArray;

    }

    factory.triggerActions = function (fieldIds, dataToAdd, sourceRecordId) {
        let apiBase = Configuration.getEvervaultInboundRelayUrl() + 'trigger-cross-bloc-data-actions';
        let data = {
            fieldIds: fieldIds,
            dataToAdd: dataToAdd,
            sourceRecordId: sourceRecordId
        };
        return $http.post(apiBase, data);
    }

    factory.getScanStationDataRecordByFieldMatchingPairs = function (fieldId, dataToAdd, fieldMatchingPairs, stationIdToLookup) {
        let apiBase = Configuration.getEvervaultInboundRelayUrl() + 'get-scan-station-data-record-by-field-matching-pairs';
        let config = {
            params : {
                fieldId: fieldId,
                dataToAdd: dataToAdd,
                fieldMatchingPairs: fieldMatchingPairs,
                stationIdToLookup: stationIdToLookup
            }
        };

        return $http.get(apiBase, config);
    }

    /*
 * Create an array of hours in a day
 * @returns {Array}
 */
    factory.createHourArray = function() {
        let hours = [];
        for (let i = 0; i < 24; i++) {
            if (i < 10) {
                hours.push({"value": i, "text": `0${i}:00`});
            } else {
                hours.push({"value": i, "text": `${i}:00`});
            }
        }
        return hours;
    }

    /*
    * Create an array of days in a month
    * @returns {Array}
    */
    factory.createDayArray = function() {
        let days = [];
        for (let i = 1; i <= 31; i++) {
            if (i < 10) {
                days.push({"value": `0${i}`, "text": `0${i}`});
            } else {
                days.push({"value": i, "text": `${i}`});
            }
        }
        days.push({"value": "last", "text": "Last day of month"});
        return days;
    }

    /**
     * Method responsible for validating fields
     * @param localFieldId
     * @param condition
     * @param valueToCompare
     * @returns void or error
     */
    factory.validate = function (localFieldId: string, condition: string, valueToCompare: string): void | Error {

        if (!localFieldId) {
            throw new Error('Local Field to check is not defined or empty');
        }

        if (!condition) {
            throw new Error('Condition is not defined or empty');
        }

        if (!valueToCompare) {
            throw new Error('Value to compare is not defined or empty');
        }

        if (condition !== 'equal' && condition !== 'notEqual' && !Number(valueToCompare)) {
            throw new Error('Strings must use condition Equal');
        }
    }

    /**
     * Method responsible for adding conditions
     * @param conditions array of conditions
     * @param localFieldId id of the local field
     * @param condition condition to be added
     * @param valueToCompare value to compare
     * @returns conditions array with new condition
     */
    factory.add = function (conditions: any, localFieldId: string, condition: string, valueToCompare: string): any {

        localFieldId = JSON.parse(localFieldId);

        conditions[Object.keys(conditions).length] = {
            localFieldId,
            condition,
            valueToCompare
        };
        return conditions;
    }

    /**
     * Method responsible for removing conditions
     * @param conditions array of conditions
     * @param index index of condition to be removed
     * @returns conditions array without condition
     */
    factory.remove = function (conditions: any, index: number): any {

        delete conditions[index];

        // build new object with fresh keys to keep it in sync
        let fieldListForLoop = conditions;
        conditions = {};
        let i = 0;
        for (let key in fieldListForLoop) {
            conditions[i] = fieldListForLoop[key];
            i++;
        }
        return conditions;
    }

    return factory;
}

